import { useRestaurantDetailContext } from '@/features/restaurants/restaurant-detail/restaurant-detail-context'
import { RestaurantDetailOpeningHours } from '@/features/restaurants/restaurant-detail/restaurant-detail-opening-hours/restaurant-detail-opening-hours'
import { RestaurantDetailSection } from '@/features/restaurants/restaurant-detail/restaurant-detail-section'
import { RestaurantDetailSectionId } from '@/features/restaurants/restaurant-detail/utils/restaurant-detail-helpers'

export const RestaurantDetailOpeningHoursSection = () => {
    const { restaurant } = useRestaurantDetailContext()

    if (!restaurant?.openingHours?.length) return null

    return (
        <RestaurantDetailSection
            id={RestaurantDetailSectionId.OPENING_HOURS}
            title="restaurants.detail.openingHours.title"
            description="restaurants.detail.openingHours.description"
        >
            <RestaurantDetailOpeningHours styleType="static" />
        </RestaurantDetailSection>
    )
}
